export enum WEEKDAY {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export const WEEKDAY_SHORT: Record<WEEKDAY, string> = {
  [WEEKDAY.MONDAY]: 'Mon',
  [WEEKDAY.TUESDAY]: 'Tue',
  [WEEKDAY.WEDNESDAY]: 'Wed',
  [WEEKDAY.THURSDAY]: 'Thu',
  [WEEKDAY.FRIDAY]: 'Fri',
  [WEEKDAY.SATURDAY]: 'Sat',
  [WEEKDAY.SUNDAY]: 'Sun',
};

export const WEEKDAY_SEQUENCE: WEEKDAY[] = [
  WEEKDAY.MONDAY,
  WEEKDAY.TUESDAY,
  WEEKDAY.WEDNESDAY,
  WEEKDAY.THURSDAY,
  WEEKDAY.FRIDAY,
  WEEKDAY.SATURDAY,
  WEEKDAY.SUNDAY,
];

export enum DateTimeFormat {
  TimeForApi = 'kk:mm',
  Time = 'HH:mm', // 13:21
  TimeFull = 'hh:mm aaa', // 01:21 pm
  WeekdayFull = 'EEEE', // Monday
}

export interface LocationWeekdayWorkingHours {
  // Allow use different enum with same values
  // Used for handling Weekday enum from GraphQL without extra mapping
  dayOfWeek: WEEKDAY | keyof typeof WEEKDAY;
  openTime: string;
  closeTime: string;
}

export interface ScheduleListItemOpenState {
  opens: string;
  opensTitle: string;
  closes: string;
  closesTitle: string;
  is24h: boolean;
}

export interface ScheduleListItemClosedState {
  closed: true;
}

export interface ScheduleListItem {
  periodStart: string;
  periodStartTitle: string;
  periodEnd: string | null;
  periodEndTitle: string | null;
  open: ScheduleListItemOpenState | null;
  closed: ScheduleListItemClosedState | null;
}

export interface FormattedScheduleListItem {
  period: string;
  timeSchedule: string;
}

export interface LocationSchedule {
  state: {
    opensToday: string;
    closesToday: string;
    opensNext: string;
    openedToday: boolean;
  } | null;
  is24h: boolean; // "TRUE" if each day of week is 24h
  list: ScheduleListItem[];
}

export type UseLocationScheduleParams = {
  workingHours: LocationWeekdayWorkingHours[];
};
export type UseLocationScheduleReturns = {
  schedule: LocationSchedule | null;
};

export type UseLocationScheduleListOnlyReturns = {
  list: ScheduleListItem[];
  is24h: boolean;
};

export type DefaultDayScheduleStructureProps = {
  dayOfWeek: WEEKDAY | keyof typeof WEEKDAY;
  periodStartTitle: string;
  day: LocationWeekdayWorkingHours;
};
